import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  changeItem: {
    margin: theme.spacing(1, 0),
    display: 'flex',
    alignItems: 'center'
  },
  oldValue: {
    backgroundColor: theme.colorPalette.red_50_op_10,
    color: theme.colorPalette.red_50,
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.spacing(0.5),
    margin: theme.spacing(0, 0.5)
  },
  newValue: {
    backgroundColor: theme.colorPalette.green_5_op_30,
    color: theme.colorPalette.green_30,
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.spacing(0.5),
    margin: theme.spacing(0, 0.5)
  },
  changeArrow: {
    margin: theme.spacing(0, 0.5),
    color: theme.colors.text_secondary
  },
  changeTag: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    marginRight: theme.spacing(2),
    fontSize: 10,
    borderRadius: theme.spacing(4),
    height: 24,
    minWidth: 70
  },
  changeTagChanged: {
    backgroundColor: theme.colorPalette.orange_10_op_20,
    color: theme.colorPalette.orange_50_op_10
  },
  changeTagAdded: {
    backgroundColor: theme.colorPalette.green_5_op_30,
    color: theme.colorPalette.green_30
  },
  changeTagRemoved: {
    backgroundColor: theme.colorPalette.red_50_op_10,
    color: theme.colorPalette.red_50
  },
  changeTagAdditional: {
    backgroundColor: theme.colors.form__background_secondary,
    color: theme.colors.text_secondary
  },
  pipReqestedChangesListItem: {
    margin: theme.spacing(0.5, 2, 0.5, 0),
    display: 'block',
    fontSize: 12
  }
}));

export default useStyles;
